import React from 'react';
import { IconsPros } from './types';

/**
 * Mobile Icon component
 *
 * @returns JSX.ELEMENT
 */
export const MobileIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M12.5,0h-9a1,1,0,0,0-1,1V15a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1V1A1,1,0,0,0,12.5,0ZM8,15a1,1,0,1,1,1-1A1,1,0,0,1,8,15Zm4.5-3.25a.25.25,0,0,1-.25.25H3.75a.25.25,0,0,1-.25-.25V1.25A.25.25,0,0,1,3.75,1h8.5a.25.25,0,0,1,.25.25Z" />
    </svg>
  );
};
